import { z } from 'zod'

import { StringDtoSchema } from '@hcr/api/shared'

import { LinkDtoBaseSchema } from './LinkDtoBase'

export const LinkSelfDtoSchema = LinkDtoBaseSchema.extend({
  target: z.literal('self'),
  url: StringDtoSchema.url(),
})

export type LinkSelfDto = z.infer<typeof LinkSelfDtoSchema>

export const isLinkSelfDto = (x: unknown): x is LinkSelfDto => LinkSelfDtoSchema.safeParse(x).success
